import React, {useContext, useEffect, useState, useRef} from 'react';

import firebase from 'firebase';
import * as lodash from 'lodash';
import * as fs from 'file-saver';
import * as dataManager from '../adapters/data';

import {Button} from 'semantic-ui-react';

import { GlobalContext } from '../contexts/GlobalContext';

import AddEmployeeModal from '../components/AddEmployeeModal';
import AddPositionModal from '../components/AddPositionModal';
import AddQualificationModal from '../components/AddQualificationModal';
import EditEmployeeModal from '../components/EditEmployeeModal';
import EditPositionModal from '../components/EditPositionModal';
import EditQualificationModal from '../components/EditQualificationModal';
import ConfirmDeleteModal from '../components/ConfirmDeleteModal';
import MessageModal from '../components/MessageModal';
import GeneratedScheduleModal from '../components/GeneratedScheduleModal';
import NavBar from '../components/NavBar';
import EmployeesPage from '../components/EmployeesPage';
import PositionsPage from '../components/PositionsPage';
import QualificationsPage from '../components/QualificationsPage';
import SchedulesPage from '../components/SchedulesPage';
import SetEmployeeCellModal from '../components/SetEmployeeCellModal';
import SetPositionCellModal from '../components/SetPositionCellModal';
import SetQualsCellModal from '../components/SetQualsCellModal';
import ImportPositionCellModal from '../components/ImportPositionCellModal';


const Employee = (props)  => {
    return (
        <div>
            <h2>{props.name} - {props.qualifications}</h2>
            <Button negative onClick={props.confirmDeleteCallback}>Delete</Button> <Button positive onClick={props.editEmployeeCallback}>Edit</Button>
        </div>
    );
}

const Position = (props)  => {
    return (
        <div>
            <h2>{props.name} - {props.qualifications}</h2>
            <Button negative onClick={props.confirmDeleteCallback}>Delete</Button> <Button positive onClick={props.editPositionCallback}>Edit</Button>
        </div>
    );
}

const Qualification = (props)  => {
    return (
        <div>
            <h2>{props.name} - {props.description}</h2>
            <Button negative onClick={props.confirmDeleteCallback}>Delete</Button> <Button positive onClick={props.editQualificationCallback}>Edit</Button>
        </div>
    );
}

const Home = (props) => {

    const [activePage, setActivePage] = useState('employees');

    const [showEmployees, setShowEmployees] = useState(true);
    const [showPositions, setShowPositions] = useState(false);



    /// MODALS
    const [addEmployeeModalOpen, setAddEmployeeModalOpen] = useState(false);

    const [addPositionModalOpen, setAddPositionModalOpen] = useState(false);

    const [addQualificationModalOpen, setAddQualificationModalOpen] = useState(false);

    const [messageModalOpen, setMessageModalOpen] = useState(false);

    const [generatedScheduleModalOpen, setGeneratedScheduleModalOpen] = useState(false);

    const [employeeCellModalOpen, setEmployeeCellModalOpen] = useState(false);
    const [qualsCellModalOpen, setQualsCellModalOpen] = useState(false);
    const [importPositionCellModalOpen, setImportPositionCellModalOpen] = useState(false);
    const [positionCellModalOpen, setPositionCellModalOpen] = useState(false);

    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editModalName, setEditModalName] = useState('');
    const [editModalId, setEditModalId] = useState('');
    const [editModalQuals, setEditModalQuals] = useState([]);

    const [editPositionModalOpen, setEditPositionModalOpen] = useState(false);
    const [editPositionModalName, setEditPositionModalName] = useState('');
    const [editPositionModalId, setEditPositionModalId] = useState('');
    const [editPositionModalQuals, setEditPositionModalQuals] = useState([]);
    const [editPositionModalTimeslot, setEditPositionModalTimeslot] = useState('');

    const [editQualificationModalOpen, setEditQualificationModalOpen] = useState(false);
    const [editQualificationModalName, setEditQualificationModalName] = useState('');
    const [editQualificationModalDescription, setEditQualificationModalDescription] = useState('');
    const [editQualificationModalId, setEditQualificationModalId] = useState('');
    const [editQualificationModalEmployees, setEditQualificationModalEmployees] = useState([]);
    /// MODALS


    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [confirmDeleteType, setConfirmDeleteType] = useState('employee');
    const [confirmDeleteHeader, setConfirmDeleteHeader] = useState('');
    const [confirmDeleteMessage, setConfirmDeleteMessage] = useState('');
    const [confirmDeleteName, setConfirmDeleteName] = useState('');
    const [confirmDeleteId, setConfirmDeleteId] = useState('');

    const [state, setState] = useContext(GlobalContext);

    useEffect(() => {
        // localStorage.clear();
        loadStateFromFile();
        // displayAllEmployees(false);
        // displayAllPositions(false);
        // displayAllQualifications(false);
    }, []);
    

    const toggleAddEmployeeModal = () => {
        setAddEmployeeModalOpen(!addEmployeeModalOpen);
    }

    const toggleAddPositionModal = () => {
        setAddPositionModalOpen(!addPositionModalOpen);

    }

    const toggleAddQualificationModal = () => {
        setAddQualificationModalOpen(!addQualificationModalOpen);
    }

    const toggleEditEmployeeModal = () => {
        setEditModalOpen(!editModalOpen);
    }

    const toggleEditPositionModal = () => {
        setEditPositionModalOpen(!editPositionModalOpen);
    }

    const toggleEditQualificationModal = () => {
        setEditQualificationModalOpen(!editQualificationModalOpen);
    }

    const toggleMessageModal = () => {
        setMessageModalOpen(!messageModalOpen);
    }

    const toggleGeneragedScheduleModal = () => {
        setGeneratedScheduleModalOpen(!generatedScheduleModalOpen);
    }

    const togglePositionCellModal = () => {
        setPositionCellModalOpen(!positionCellModalOpen);
    }

    const toggleEmployeeCellModal = () => {
        if (state['selectedCells'].length === 0) {
            setState( prevState => {
                return {
                    ...prevState, 
                    messageModal: {
                        header: 'Error',
                        message: 'Highlight the cells you wish to import as employees'
                    }
    
                }
            });

            setMessageModalOpen(true);
            return;
        }

        
        setEmployeeCellModalOpen(!employeeCellModalOpen);
    }

    const toggleQualsCellModal = () => {

        if (state['selectedCells'].length === 0) {
            setState( prevState => {
                return {
                    ...prevState, 
                    messageModal: {
                        header: 'Error',
                        message: 'Highlight the cells you wish to import as qualifications'
                    }
    
                }
            });

            setMessageModalOpen(true);
            return;
        }

        setQualsCellModalOpen(!qualsCellModalOpen);
    }

    const toggleImportPositionCellModal = () => {
        if (state['selectedCells'].length === 0) {
            setState( prevState => {
                return {
                    ...prevState, 
                    messageModal: {
                        header: 'Error',
                        message: 'Highlight the cells you wish to import as positions'
                    }
    
                }
            });

            setMessageModalOpen(true);
            return;
        }

        
        setImportPositionCellModalOpen(!importPositionCellModalOpen);
    }

    const showEditSuccess = () => {
        toggleEditEmployeeModal();

        displayAllEmployees();

        setState( prevState => {
            return {
                ...prevState, 
                messageModal: {
                    header: 'Success',
                    message: 'Employee edited successfully'
                }

            }
        });

        console.log(state);
        setMessageModalOpen(true);

        
    }

    const showEditPositionSuccess = () => {
        toggleEditPositionModal();

        displayAllPositions();

        setState( prevState => {
            return {
                ...prevState, 
                messageModal: {
                    header: 'Success',
                    message: 'Position edited successfully'
                }

            }
        });

        setMessageModalOpen(true);

    }

    const showEditQualificationSuccess = () => {
        toggleEditQualificationModal();

        displayAllQualifications();

        setState( prevState => {
            return {
                ...prevState, 
                messageModal: {
                    header: 'Success',
                    message: 'Qualification edited successfully'
                }

            }
        });

        setMessageModalOpen(true);

    }

    const addEmployeeSuccess = () => {
        toggleAddEmployeeModal();

        setState( prevState => {
            return {
                ...prevState, 
                messageModal: {
                    header: 'Success',
                    message: 'Employee added successfully'
                }

            }
        });


        setMessageModalOpen(true);
    }

    const importEmployeeSuccess = () => {
        setEmployeeCellModalOpen(false);

        setState( prevState => {
            return {
                ...prevState, 
                messageModal: {
                    header: 'Success',
                    message: 'Employee added successfully'
                }

            }
        });


        setMessageModalOpen(true);
    }

    const importPositionSuccess = () => {
        setImportPositionCellModalOpen(false);

        setState( prevState => {
            return {
                ...prevState, 
                messageModal: {
                    header: 'Success',
                    message: 'Position added successfully'
                }

            }
        });


        setMessageModalOpen(true);
    }

    const importQualsSuccess = () => {
        setQualsCellModalOpen(false);

        setState( prevState => {
            return {
                ...prevState, 
                messageModal: {
                    header: 'Success',
                    message: 'Qualification added successfully'
                }

            }
        });


        setMessageModalOpen(true);
    }

    const showAddSuccess = () => {
        toggleAddPositionModal();

        setState( prevState => {
            return {
                ...prevState, 
                messageModal: {
                    header: 'Success',
                    message: 'Position added successfully'
                }

            }
        });

        setMessageModalOpen(true);
    }

    const displayAllEmployees = (changePage = true) => {
        console.log('displayAllEmployees');

        let e = dataManager.loadEmployees();
        setState( prevState => {
            // saveStateToFile({
            //     ...prevState,
            //     employees: e
            // });

            return {
                ...prevState,
                employees: e
            };
        });

        
        // firebase.firestore().collection('employees').get().then(snapshot => {
        //     // console.log(snapshot.docs.map(doc => doc));

        //     let e = [];
        //     for (let i=0; i<snapshot.docs.length; i++) {
        //         e.push( {
        //             id: snapshot.docs[i].id,
        //             name: snapshot.docs[i].get('name'),
        //             qualifications: snapshot.docs[i].get('qualifications')
        //         });
        //         // console.log(snapshot.docs[i].id);
        //         // console.log(snapshot.docs[i].get('name'));
        //         // console.log(snapshot.docs[i].get('qualifications'));
        //     }
            
        //     console.log('e TEST - ', JSON.stringify(e));
        //     setState( prevState => {
        //         saveStateToFile({
        //             ...prevState,
        //             employees: e
        //         });

        //         return {
        //             ...prevState,
        //             employees: e
        //         };
        //     });
        //     // setState( { user: state['user'], employees: e, positions: state['positions'], editModal: state['editModal'], messageModal: state['messageModal'] });
        // });

        if (changePage)
            setActivePage('employees');
    }

    const displayAllPositions = (changePage = true) => {
        console.log('displayAllPositions');

        let p = dataManager.loadPositions();
        setState( prevState => {
            // saveStateToFile({
            //     ...prevState,
            //     positions: p
            // });

            return {
                ...prevState,
                positions: p
            };
        });

        // firebase.firestore().collection('positions').get().then(snapshot => {
        //     // console.log(snapshot.docs.map(doc => doc));

        //     let p = [];
        //     for (let i=0; i<snapshot.docs.length; i++) {
        //         p.push( {
        //             id: snapshot.docs[i].id,
        //             name: snapshot.docs[i].get('name'),
        //             qualifications: snapshot.docs[i].get('qualifications'),
        //             timeslot: snapshot.docs[i].get('timeslot')
        //         });
        //         // console.log(snapshot.docs[i].id);
        //         // console.log(snapshot.docs[i].get('name'));
        //         // console.log(snapshot.docs[i].get('qualifications'));
        //     }
        //     setState( prevState => {
        //         saveStateToFile({
        //             ...prevState,
        //             positions: p
        //         });

        //         return {
        //             ...prevState,
        //             positions: p
        //         };
        //     });
        //     // setState( { user: state['user'], employees: state['employees'], positions: p, editModal: state['editModal'], messageModal: state['messageModal'] });
        // });

        if (changePage)
            setActivePage('positions');
    }

    const displayAllQualifications = (changePage = true) => {
        console.log('displayAllQualifications');
        

        let q = dataManager.loadQualifications();
        setState( prevState => {
            // saveStateToFile({
            //     ...prevState,
            //     qualifications: q
            // });

            return {
                ...prevState,
                qualifications: q
            };
        });

        // firebase.firestore().collection('qualifications').get().then(snapshot => {

        //     let q = [];
        //     for (let i=0; i<snapshot.docs.length; i++) {
        //         q.push( {
        //             id: snapshot.docs[i].id,
        //             name: snapshot.docs[i].get('name'),
        //             description: snapshot.docs[i].get('description')
        //         });

        //     }
        //     setState( prevState => {
        //         saveStateToFile({
        //             ...prevState,
        //             qualifications: q
        //         });
                
        //         return {
        //             ...prevState,
        //             qualifications: q
        //         };
        //     });

        // });

        if (changePage)
            setActivePage('qualifications');
        
    }

    const generateSchedule = (changePage = true) => {
        // console.log('Generate schedule');

        // let e = lodash.cloneDeep(state['employees']);
        // e.sort( () => Math.random() - 0.5);
        // let p = state['positions'];
        // p.sort( () => Math.random() - 0.5);
        // let filled = false;
        // let tempSchedule = [];


        // for (let i = 0; i < p.length; i++) {
        //     filled = false;
        //     for (let j = 0; j < e.length; j++) {

        //         if ( p[i].qualifications.every(value => e[j].qualifications.includes(value)) ) {

        //             if (e[j].placed == null) {
        //                 console.log('employee '+ e[j].name + ' is qualified for ' + p[i].name);
        //                 tempSchedule.push( {position: p[i], employee: e[j]});
        //                 filled = true;
        //                 e[j].placed = true;
        //                 break;
        //             }
        //         }
        //         else {
        //             console.log('employee ' + e[j].name + ' is not qualified for ' + p[i].name);
        //         }

        //     }

        //     if (filled === false) {
        //         tempSchedule.push( {position: p[i], employee: null });
        //         console.log('Position ' + p[i].name + ' could not be filled.');
        //     }
        // }

        // setState( prevState => {
        //     return {
        //         ...prevState, 
        //         schedule: tempSchedule

        //     }
        // });

        // console.log('Schedule Generated.');
        // console.log(tempSchedule);
        // toggleGeneragedScheduleModal();

        if (changePage) {
            // GO TO SCHEDULES PAGE.
            setActivePage('schedules');
        }

    }

    const saveStateToFile = (state, filename = 'workspace.txt') => {
        console.log(`SAVE STATE TO FILE - ${filename} `)
        console.log(`STATE - ${JSON.stringify(state)}`);
        // var blob = new Blob([JSON.stringify(state)], {type: "application/json;charset=utf-8"});
        // fs.saveAs(blob, filename);

        dataManager.saveState(state);
    }

    const loadStateFromFile = (filename = 'workspace.txt') => {
        console.log(`LOAD STATE FROM FILE - ${filename} `)

        setState( (prev) => {
            return {...prev, ...dataManager.loadState()};
        });
        
        
        // let fileReader = new FileReader();
        // let jsonObject = null;
        // fileReader.onload = (e) => {
        //     jsonObject = JSON.parse(e.target.result);
        //     console.log(jsonObject);
        //     setState(jsonObject);
        // }
        // fileReader.readAsText(filename);
    }


    const confirmDeleteCb = (type, header, message, name, id) => {
       return ( ) => {
            setConfirmDeleteType(type);
            setConfirmDeleteOpen(!confirmDeleteOpen);
            setConfirmDeleteHeader(header);
            setConfirmDeleteMessage(message);
            setConfirmDeleteName(name);
            setConfirmDeleteId(id);

            setEditModalOpen(false);
            setEditPositionModalOpen(false);
            setEditQualificationModalOpen(false);

        }
    }

    const editEmployeeCb = (name, id, qualifications) => {
        return () => {
            setEditModalOpen(!editModalOpen);
            setEditModalName(name);
            setEditModalId(id);
            setEditModalQuals(qualifications);


            setState( prevState => {
                return {
                    ...prevState,
                    editModal: { name: name, id: id, qualifications: qualifications}
                };
            });

            // setState({
            //     user: state['user'], employees: state['employees'],  positions: state['positions'],
            //     editModal: { name: name, id: id, qualifications: qualifications},
            //     messageModal: state['messageModal']
            // });
        }
    }

    const editPositionCb = (name, id, qualifications, timeslot) => {
        return () => {
            setEditPositionModalOpen(!editPositionModalOpen);
            setEditPositionModalName(name);
            setEditPositionModalId(id);
            setEditPositionModalQuals(qualifications);
            setEditPositionModalTimeslot(timeslot);


            setState( prevState => {
                return {
                    ...prevState,
                    editPositionModal: { name: name, id: id, qualifications: qualifications, timeslot: timeslot}
                };
            });
        }
    }

    const editQualificationCb = (name, id, description, employees) => {
        return () => {
            setEditQualificationModalOpen(!editQualificationModalOpen);
            setEditQualificationModalName(name);
            setEditQualificationModalId(id);
            setEditQualificationModalDescription(description);
            setEditQualificationModalEmployees(employees);


            setState( prevState => {
                return {
                    ...prevState,
                    editQualificationModal: { name: name, id: id, description: description, employees: employees}
                };
            });
        }
    }


    // return (
    //     <React.Fragment>
    //         <NavBar />
    //     </React.Fragment>
    // );


    
    return (
        <React.Fragment>
            <NavBar employeesCb={displayAllEmployees}
                    positionsCb={displayAllPositions}
                    qualificationsCb={displayAllQualifications}
                    schedulesCb={generateSchedule} 
                    saveStateCb={saveStateToFile}
            />

            {/* <Button positive onClick={displayAllEmployees}>Display All Employees</Button>
            <Button positive onClick={displayAllPositions}>Display All Positions</Button>
            <Button positive onClick={toggleAddEmployeeModal}>Add Employee</Button>
            <Button positive onClick={toggleAddPositionModal}>Add Position</Button>
            <Button positive onClick={toggleAddQualificationModal}>Add Qualification</Button>
            <Button positive onClick={generateSchedule}>Generate Schedule</Button> */}

            <EmployeesPage active={activePage} 
                confirmDeleteCb={confirmDeleteCb} 
                addEmployeeCb={toggleAddEmployeeModal} 
                editEmployeeCb={editEmployeeCb} 
                setEmployeeCellCb={toggleEmployeeCellModal}
                setQualsCellCb={toggleQualsCellModal}
                setPositionCellCb={toggleImportPositionCellModal}

                />

            <PositionsPage active={activePage} 
                confirmDeleteCb={confirmDeleteCb} 
                addPositionCb={toggleAddPositionModal} 
                editPositionCb={editPositionCb} 
                />

            <QualificationsPage active={activePage} 
                confirmDeleteCb={confirmDeleteCb} 
                addQualificationCb={toggleAddQualificationModal} 
                editQualificationCb={editQualificationCb} 
                />

            <SchedulesPage active={activePage}
                setPositionCellCb={togglePositionCellModal}
                />

            {/* <div style={{display: `'${showPositions}'`}}>
                <h3>Positions</h3>
                {
                    state['positions'] ?
                    state['positions'].map(position => (
                        <Position name={position.name} qualifications={position.qualifications} timeslot={position.timeslot}
                        confirmDeleteCallback={confirmDeleteCb('position', 'Delete Position', ' position?', position.name, position.id)}
                        editPositionCallback={editPositionCb(position.name, position.id, position.qualifications, position.timeslot)}
                        />
                    )) : <p>No positions</p>
                }
            </div> */}

            {/* <div style={{display: `'${showPositions}'`}}>
                <h3>Qualifications</h3>
                {
                    state['qualifications'] ?
                    state['qualifications'].map(qual => (
                        <Qualification name={qual.name} description={qual.description} 
                        confirmDeleteCallback={confirmDeleteCb('qualification', 'Delete Qualification', ' qualification?', qual.name, qual.id)}
                        editQualificationCallback={editQualificationCb(qual.name, qual.id, qual.description)}
                        />
                    )) : <p>No qualifications</p>
                }
            </div> */}

            <MessageModal show={messageModalOpen} onClose={toggleMessageModal} />
            <AddEmployeeModal show={addEmployeeModalOpen} refreshListCb={displayAllEmployees} onClose={toggleAddEmployeeModal} onAdd={addEmployeeSuccess} />
            <AddPositionModal show={addPositionModalOpen} refreshListCb={displayAllPositions} onClose={toggleAddPositionModal} onAdd={showAddSuccess} />
            <AddQualificationModal show={addQualificationModalOpen} refreshListCb={displayAllQualifications} onClose={toggleAddQualificationModal} />
            <EditEmployeeModal show={editModalOpen} confirmDeleteCallback={confirmDeleteCb} refreshListCb={displayAllEmployees} onEdit={showEditSuccess} onClose={toggleEditEmployeeModal} name={editModalName} id={editModalId} qualifications={editModalQuals} />
            <EditPositionModal show={editPositionModalOpen} confirmDeleteCallback={confirmDeleteCb} refreshListCb={displayAllPositions} onEdit={showEditPositionSuccess} onClose={toggleEditPositionModal} name={editPositionModalName} id={editPositionModalId} qualifications={editPositionModalQuals} timeslot={editPositionModalTimeslot} />
            <EditQualificationModal show={editQualificationModalOpen} confirmDeleteCallback={confirmDeleteCb} refreshListCb={displayAllQualifications} onEdit={showEditQualificationSuccess} onClose={toggleEditQualificationModal} name={editQualificationModalName} description={editQualificationModalDescription} id={editQualificationModalId} employees={editQualificationModalEmployees} />
            <ConfirmDeleteModal show={confirmDeleteOpen} refreshListCb={confirmDeleteType ==='employee' ? displayAllEmployees : confirmDeleteType === 'position' ? displayAllPositions  : displayAllQualifications} onClose={confirmDeleteCb(null)} type={confirmDeleteType} header={confirmDeleteHeader} message={confirmDeleteMessage} name={confirmDeleteName} id={confirmDeleteId} />
            <SetEmployeeCellModal show={employeeCellModalOpen} refreshListCb={displayAllEmployees} onClose={toggleEmployeeCellModal} onAdd={importEmployeeSuccess} />
            <SetQualsCellModal show={qualsCellModalOpen} refreshListCb={displayAllQualifications} onClose={toggleQualsCellModal} onAdd={importQualsSuccess} />
            <ImportPositionCellModal show={importPositionCellModalOpen} refreshListCb={displayAllEmployees} onClose={toggleImportPositionCellModal} onAdd={importPositionSuccess} />

            <SetPositionCellModal show={positionCellModalOpen} refreshListCb={displayAllEmployees} onClose={togglePositionCellModal} />


            <GeneratedScheduleModal show={generatedScheduleModalOpen} onClose={toggleGeneragedScheduleModal} />
        </React.Fragment>
    );

};

export default Home;